import { computed, createApp } from 'vue';
import UpdatePosDataLoading from '@/components/orderDialog/UpdatePosDataLoading.vue';
import store from '@/store';
import { useConfirm } from '@/utils/confirm';

// 確認更新彈窗
export const openUpdateConfirm = () => {
  const getVersionText = computed(() => store.getters['updatePosData/getVersionText']);
  useConfirm({
    title: '登出並更新',
    content: `${getVersionText.value}更新將耗時數分鐘，會登出並清空資料，是否立即更新？`,
    confirmText: '登出並更新',
    cancelText: '稍後再說',
  })
    .then(async () => {
      await store.dispatch('updatePosData/doUpdatePosData');
      useUpdateLoading(true);
      store.dispatch('system/doLogout');
    })
    .catch((e) => e);
};

// 更新蓋板畫面
let loadingDom;
export const useUpdateLoading = (status) => {
  const div = document.querySelector('#update-loading');
  if (div) div.remove();
  if (status) {
    loadingDom = createApp(UpdatePosDataLoading).mount(document.createElement('div'));
    document.body.appendChild(loadingDom.$el);
  }
};
